import { Stepper } from "@shoptet/ui";
import { useTranslation } from "react-i18next";

const MetaWizardStepper = ({ activeStep }: { activeStep: number }) => {
  const { t } = useTranslation("translation", { keyPrefix: "Wizard Meta Stepper" });
  const STEPS: [string, string, ...string[]] = [
    t("Preview"),
    t("Facebook page"),
    t("Products"),
    t("Advertisement"),
    t("Budget"),
    t("Credit"),
  ];
  return <Stepper activeStep={activeStep} steps={STEPS} />;
};

export default MetaWizardStepper;
